"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _loading = require("./loading.js");
var _quiz = require("./quiz.js");
var _params = require("./params.js");
var _response = require("../helpers/response.js");
var getBlockQuestionIndex = function getBlockQuestionIndex(quiz, question) {
  var currentBlockIds = quiz.get('currentBlockQuestionIds');
  if (!currentBlockIds || !question) return false;
  return currentBlockIds.findIndex(function (bId) {
    return bId === question.get('id');
  });
};
var TakingQuizHooks = /*#__PURE__*/_createClass(function TakingQuizHooks(_ref) {
  var _this = this;
  var Quizzes = _ref.Quizzes,
    StrikeThroughs = _ref.StrikeThroughs;
  _classCallCheck(this, TakingQuizHooks);
  this.useDisableAnswerSelection = function (quiz, question, isResponseSyncing, isLoadingNext) {
    if (!question) return true;
    if (isResponseSyncing || isLoadingNext) return true;
    var groupQuestionIds = question.get('group_question_ids');
    var isSearchOrReview = quiz.get('type') === 'search' || quiz.get('type') === 'study';
    var isNgnTestMode = quiz.get('type') === 'test' && quiz.get('is_ngn');
    if (isSearchOrReview || !groupQuestionIds.size || isNgnTestMode) return false;
    var groupIndex = question.get('group_index');
    var remainingQuestionIds = groupQuestionIds.slice(groupIndex + 1);
    var seenCaseQuestions = quiz.get('seen_case_question_ids');
    return remainingQuestionIds.some(function (id) {
      return seenCaseQuestions.find(function (seenId) {
        return seenId === id;
      });
    });
  };
  this.useCanClickPrevious = function (quiz, questions, question, questionNumber) {
    // Cannot go lower than 1
    if (questionNumber <= 1) return false;
    // Cannot currently go back from a block in practice exams
    if (quiz.get('isBlockQuiz') && getBlockQuestionIndex(quiz, question) === 0) return false;
    // Incomplete Adaptive mode quizzes cannot go backwards
    if (quiz.get('type') === 'adaptive' && quiz.get('currentStatus') !== 'complete') return false;
    // Cannot go to previous question until it is loaded
    if (!questions.has(quiz.get('question_ids').get(questionNumber - 2))) return false;
    return !quiz.get('readyToSubmit');
  };
  this.usePatientTabGroup = function (questionId, groupId) {
    var questionPatientBox = (0, _reactRedux.useSelector)(function (state) {
      return state.patientTabGroups.get(questionId);
    });
    var groupPatientBox = (0, _reactRedux.useSelector)(function (state) {
      return state.patientTabGroups.get(groupId);
    });
    return groupPatientBox || questionPatientBox;
  };
  this.useRestrictLabValues = function () {
    var session = (0, _reactRedux.useSelector)(function (state) {
      return state.session;
    });
    return session.get('isIframe') && [227, 228].includes(session.get('selected_question_bank_id'));
  };
  this.Quizzes = Quizzes;
  this.StrikeThroughs = StrikeThroughs;
  this.useOnStrikeoutAnswer = function (quiz, currentTool, dispatch) {
    return function (ev, answerId) {
      if (currentTool === 'strikeout' || quiz.get('boardExamInterface') === 'fred') {
        ev.preventDefault(); // we don't want strikeout to trigger answer selection
        ev.stopPropagation(); // stop strikeout from firing on all answer label children

        var existingStrikethrough = quiz.get('strike_throughs').find(function (strikethrough) {
          return strikethrough.get('answer_id') === answerId;
        });
        if (existingStrikethrough && !existingStrikethrough.get('deleted')) {
          dispatch(_this.StrikeThroughs.strikeThroughDestroy(quiz.get('id'), answerId));
        } else {
          dispatch(_this.StrikeThroughs.strikeThroughCreate(quiz.get('id'), answerId));
        }
      }
    };
  };

  // Next button may be disabled for various reasons
  this.useCanClickNext = function (quiz, questions, question, questionNumber, isAact) {
    var isLoadingNext = (0, _loading.useIsLoading)(_this.Quizzes.quizQuestionFetchNext, quiz.get('id'));
    var isLoadingAnyQuestions = (0, _loading.useIsLoading)(/^questions\//);
    var responses = (0, _reactRedux.useSelector)(function (state) {
      return state.responses.get(quiz.get('id'), new Map());
    });
    var response = responses.get(question.get('id'));
    var isAnswered = !(response !== null && response !== void 0 && response.get('is_aact')) && !!(response !== null && response !== void 0 && response.get('user_input')) || (response === null || response === void 0 ? void 0 : response.get('is_aact')) && (response === null || response === void 0 ? void 0 : response.get('can_submit'));
    if (quiz.get('type') === 'search' && isLoadingAnyQuestions) return false;
    // Incomplete Adaptive mode quizzes have special rules
    if (quiz.get('type') === 'adaptive' && quiz.get('currentStatus') !== 'complete') {
      // Must answer question before proceeding in Adaptive mode
      if (!isAnswered) return false;
      // Disable button if it was already clicked
      if (isLoadingNext) return false;
    } else {
      if (isAact && quiz.get('currentStatus') !== 'complete' && !isAnswered) return false;
      // Cannot go higher than question count
      if (questionNumber >= quiz.get('questionCount')) return false;
      // Cannot go to next question until it is loaded
      if (!questions.has(quiz.get('question_ids').get(questionNumber))) return false;
      // practice exam
      if (quiz.get('isBlockQuiz')) {
        var questionIndex = getBlockQuestionIndex(quiz, question);
        return questionIndex + 1 !== quiz.get('currentQuizBlock').get('question_ids').size;
      }
    }
    return !quiz.get('readyToSubmit');
  };

  /* These are items used in 2 or more interface versions of QuizQuestion
     Please only add here if functionality is shared.*/
  this.useQuestionEssentials = function (questionId, response, currentTool) {
    var quiz = (0, _quiz.useCurrentQuiz)();
    var dispatch = (0, _reactRedux.useDispatch)();
    var questions = (0, _reactRedux.useSelector)(function (state) {
      return state.questions;
    });
    var questionNumber = (0, _params.useCurrentQuestionNumber)();
    var onStrikeoutAnswer = _this.useOnStrikeoutAnswer(quiz, currentTool, dispatch);
    var question = questions.get(questionId);
    var canClickNext = _this.useCanClickNext(quiz, questions, question, questionNumber, question === null || question === void 0 ? void 0 : question.get('aact_type'));
    var canClickPrevious = _this.useCanClickPrevious(quiz, questions, question, questionNumber);
    var ungraded = quiz.get('type') === 'tutor' && response && response.get('ungraded_user_input') !== null;
    var isCorrect = response === null || response === void 0 ? void 0 : response.get(ungraded ? 'ungraded_correct' : 'correct');
    var selectedAnswers = (0, _response.responseSelectedAnswers)(response, question.get('type'), ungraded);
    var isIncomplete = quiz.get('currentStatus') !== 'complete';
    var hasExhibits = question.get('images').size > 0 || !!question.get('video_html') || question.get('resources').size > 0;
    return {
      quiz: quiz,
      question: question,
      questionNumber: questionNumber,
      canClickNext: canClickNext,
      isCorrect: isCorrect,
      selectedAnswers: selectedAnswers,
      isIncomplete: isIncomplete,
      hasExhibits: hasExhibits,
      canClickPrevious: canClickPrevious,
      onStrikeoutAnswer: onStrikeoutAnswer
    };
  };
});
var _default = exports.default = TakingQuizHooks;